<template>
  <d-navbar-nav class="border-left flex-row" style="width:17%">
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-nowrap px-3"  v-d-toggle.user-actions>
        <img class="user-avatar rounded-circle mr-2" :src="image_url" alt="User Avatar" style="height:25px;width:25px;display:none;"> <span class="d-none d-md-inline-block">{{ name }}</span>
      </a>
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small" >
        <d-dropdown-item> <a href="javascript:return false" @click="profile" style="text-decoration:none;color:black;"><i class="material-icons">&#xE8B8;</i> Edit Profile</a></d-dropdown-item>
        <d-dropdown-divider />
        <d-dropdown-item href="#" class="text-danger" >
          <a href="javasript:return false" @click="logout" class="text-danger" style="text-decoration:none;visited:none"><i class="material-icons text-danger">&#xE879;</i> Logout</a>
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<style>
  .nav-link:hover {
    cursor: pointer;
  }
  .right_align{
    right:0 !important;
    left: auto;
  }
</style>
<script>
import env from '../../../env.vue';
export default {
  data(){
    return {
      name: '',
      image_url: '',
      isHam:true,
    }
  },
  methods:{
    logout: function(){
      this.$store.commit('token','');
      self.location='/prayer.admin/';
    },
    profile:function(){
      this.$router.push({name:'user-profile'});
    },
    test:function(){
      let ua = document.getElementById('user-actions');
      if ( parseInt(ham)!=0 )
        this.isHam=false
      else 
        this.isHam=true
    }
  },
  mounted(){
    let ham = document.getElementById('hamburger').clientHeight;
    if ( ham!=0 ) this.isHam=false;
    else 
      this.isHam=true;
    this.name=this.$store.state.fullname;
    this.image_url=env.images_url+'/profiles/'+this.$store.state.profile_picture;
  }
}
</script>
